import React from 'react';
import {
  List, Datagrid, TextField, BooleanField, NumberField, EditButton,
  Edit, SimpleForm, TextInput, NumberInput, BooleanInput,
  Create, Show, SimpleShowLayout, FunctionField,
} from 'react-admin';

export const BookingSourceList = props => (
  <List {...props} title="Źródła rezerwacji">
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Nazwa" />
      <NumberField source="commission_rate" label="Prowizja bazowa (%)" />
      <NumberField source="payment_fee_rate" label="Opłata płatnicza (%)" />
      <FunctionField
        label="Łączna stawka (%)"
        render={record => `${record.total_rate}%`}
      />
      <BooleanField source="is_active" label="Aktywna" />
      <EditButton />
    </Datagrid>
  </List>
);

const BookingSourceForm = () => (
  <SimpleForm>
    <TextInput source="name" label="Nazwa źródła" required fullWidth />
    <NumberInput
      source="commission_rate"
      label="Prowizja bazowa (%)"
      min={0}
      max={100}
      step={0.1}
      helperText="Np. 12.0 dla Booking.com"
    />
    <NumberInput
      source="payment_fee_rate"
      label="Opłata płatnicza (%)"
      min={0}
      max={100}
      step={0.1}
      helperText="Np. 1.4 dla Booking.com"
    />
    <BooleanInput source="is_active" label="Aktywna" defaultValue={true} />
  </SimpleForm>
);

export const BookingSourceEdit = props => (
  <Edit {...props} title="Edytuj źródło rezerwacji">
    <BookingSourceForm />
  </Edit>
);

export const BookingSourceCreate = props => (
  <Create {...props} title="Nowe źródło rezerwacji">
    <BookingSourceForm />
  </Create>
);

export const BookingSourceShow = props => (
  <Show {...props} title="Źródło rezerwacji">
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Nazwa" />
      <NumberField source="commission_rate" label="Prowizja bazowa (%)" />
      <NumberField source="payment_fee_rate" label="Opłata płatnicza (%)" />
      <FunctionField
        label="Łączna stawka (%)"
        render={record => `${record.total_rate}%`}
      />
      <BooleanField source="is_active" label="Aktywna" />
    </SimpleShowLayout>
  </Show>
);
